import { trackCall } from "@/lib/track";

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap">
      <div className="footer-grid">
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <img
              src="/assets/logo.webp"
              alt="DIY Tek Systems logo"
              width="52"
              height="52"
              loading="lazy"
              style={{ borderRadius: "50%" }}
            />
            <div style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: 18, color: "#fff" }}>
              DIY Tek Systems LLC
            </div>
          </div>
        </div>
        <div>
          <div className="footer-h">Contact</div>
          <p style={{ margin: 0, lineHeight: 1.7, fontSize: 15 }}>
            4507 S County Rd 1232<br />
            Midland, TX 79706<br />
            <a href="tel:+18666526569" onClick={() => trackCall("footer")} data-testid="footer-phone-866-link">866-652-6569</a>
          </p>
        </div>
        <div>
          <div className="footer-h">Product</div>
          <p className="mono" style={{ margin: 0, lineHeight: 1.9, fontSize: 12.5, letterSpacing: "0.06em" }}>
            DIY NO WELD Fence Bracket<br />
            Part 200<br />
            Patent Pending 19/642,047
          </p>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="wrap">© 2026 DIY Tek Systems, LLC · Patent Pending 19/642,047 · Made in China</div>
    </div>
  </footer>
);
